var v1="<span ng-if=\"editMode\" class=\"column-input\"><span gnp-custom-select=\"\" ng-model=\"score.sand_shot\" disable=\"!isShotEntered(score)\" options=\"defaultData.sandOptions\" class=\"input gray\"></span></span>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/sand.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/score-card/templates/sand.jade
// module id = 404
// module chunks = 0